import "core-js/modules/es.error.cause.js";
import topTitle from '@/components/title';
import { isPhone, checkEmail, getCardInfo, cityData } from '@/utils/validate';
import { certificateList, nationList, addWorkers, editWorkers } from './../../../organization/staffManage/request';
import { rankList } from './../partten';
// import {postResource} from './../../postManage/request';
// import postModel from './../../postManage/postModel.vue';
export default {
  props: ['id', 'infoObj', 'type'],
  components: {
    topTitle
    // postModel
  },
  data() {
    return {
      postShow: false,
      disabled: false,
      email: 'validating',
      loading: false,
      form: {
        sex: undefined
      },
      certificateList,
      rankList,
      sexList: [{
        name: '男',
        id: 1
      }, {
        name: '女',
        id: 2
      }],
      postList: [],
      nationList: nationList
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('姓名'),
          trigger: 'blur'
        }],
        mobile: [{
          required: true,
          validator: this.validateMobile,
          trigger: 'blur'
        }],
        certificateType: [{
          required: true,
          message: this.$t('请选择') + this.$t('证件类型'),
          trigger: 'change'
        }],
        certificateNo: [{
          required: true,
          message: this.$t('请输入') + this.$t('证件号'),
          trigger: 'blur'
        }, {
          pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
          message: this.$t('请输入') + this.$t('请输入正确的证件号'),
          trigger: 'blur'
        }, {
          validator: this.idCardValidity,
          trigger: 'blur'
        }],
        sex: [{
          required: true,
          message: this.$t('请选择') + this.$t('性别'),
          trigger: 'change'
        }],
        nation: [{
          required: true,
          message: this.$t('请选择') + this.$t('民族'),
          trigger: 'change'
        }],
        address: [{
          required: true,
          message: this.$t('请输入') + this.$t('居住地址'),
          trigger: 'blur'
        }],
        bankNo: [{
          required: true,
          validator: this.validatebankNo,
          trigger: 'blur'
        }],
        bank: [{
          required: true,
          message: this.$t('请输入') + this.$t('开户行'),
          trigger: 'blur'
        }],
        entryAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('入职时间')
        }],
        postId: [{
          required: true,
          message: this.$t('请选择') + this.$t('岗位'),
          trigger: 'change'
        }],
        rank: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('业务员职级')
        }],
        resource: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('业务员类型')
        }],
        isCertificate: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('是否持证')
        }]
      };
    }
  },
  created() {
    setTimeout(() => {
      this.disabled = this.type == 1 ? true : false;
      if (this.infoObj.companyWorkerId) {
        this.form = this.infoObj;
      } else if (this.infoObj.structureId) {
        this.form = {
          sex: undefined,
          customerId: this.infoObj.customerId,
          structureId: this.infoObj.structureId,
          structureName: this.infoObj.structureName
        };
      }
    }, 400);
    // this.postResourceFun();
  },
  methods: {
    validateMobile(rule, value, callback) {
      if (!isPhone(value)) {
        callback(new Error(this.$t('手机号格式错误')));
      } else {
        callback();
      }
    },
    validatebankNo(rule, value, callback) {
      const strBin = '10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99';
      if (!value) {
        return callback(new Error(this.$t('银行卡号不能为空')));
      } else if (!Number.isInteger(+value)) {
        callback(new Error(this.$t('银行卡号必须全为数字')));
      } else if (value.trim().length < 12 || value.trim().length > 19) {
        callback(new Error(this.$t('银行卡号长度必须在12到19之间')));
      }
      // else if (strBin.indexOf(value.substring(0, 2)) === -1) {
      //     callback(new Error('银行卡号开头6位不符合规范'))
      // }
      else {
        callback();
      }
    },
    idCardValidity(rule, code, callback) {
      let city = cityData;
      let tip = '';
      let pass = true;
      if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
        tip = this.$t('身份证号格式错误');
        pass = false;
      } else if (!city[code.substr(0, 2)]) {
        tip = this.$t('地址编码错误');
        pass = false;
      } else {
        // 18位身份证需要验证最后一位校验位
        if (code.length === 18) {
          code = code.split('');
          // ∑(ai×Wi)(mod 11)
          // 加权因子
          let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          // 校验位
          let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
          let sum = 0;
          let ai = 0;
          let wi = 0;
          for (var i = 0; i < 17; i++) {
            ai = code[i];
            wi = factor[i];
            sum += ai * wi;
          }
          let last = parity[sum % 11];
          if (parity[sum % 11] != code[17]) {
            tip = this.$t('校验位错误');
            pass = false;
          }
        }
      }
      if (!pass) {
        callback(new Error(tip));
      } else {
        callback();
      }
    },
    postResourceFun(val) {
      if (val && val.companyPostId) {
        this.form.postId = val.companyPostId;
      }
      postResource({
        customerId: this.$route.params.customerId
      }).then(res => {
        this.postList = res;
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    nextFun() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.form.email) {
            let email = true;
            console.log(999);
            if (!checkEmail(this.form.email)) {
              email = false;
              this.email = 'error';
            } else {
              this.email = 'validating';
              email = true;
            }
            if (email) {
              this.baseFun();
            } else {
              this.loading = false;
            }
          } else {
            this.baseFun();
          }
        }
      });
    },
    baseFun() {
      let obj = this.form;
      Object.assign(obj, {
        companyWorkerId: 2
      });
      this.$emit('next', obj);
      //   const fun=this.id!=-1?editWorkers:addWorkers;
      //   console.log(this.form,5333);
      //   fun(this.form).then(res=>{
      //     this.loading=false;
      //     if(res.code==200){
      //       this.$message.success('操作成功!');
      //       if(process.env.NODE_ENV === 'production'){
      //         this.$emit('next',res);
      //       }else{
      //         this.$emit('next',res.data);
      //       }
      //     }else{
      //       this.$message.error(res.message);
      //     }
      //   });
    },
    certificateNoChange() {
      if (this.form.certificateType == 1) {
        const {
          sex
        } = getCardInfo(this.form.certificateNo);
        console.log(sex, 88);
        this.form.sex = Number(sex);
        console.log(this.form);
      }
    }
    // addFun(){
    //   this.postShow=true;
    //   this.$nextTick(()=>{
    //     this.$refs.postForm.init({},false,this.infoObj.customerId);
    //   });
    // }
  }
};